import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfiguracionTipoInterfazService } from './configuracion-tipo-interfaz.service';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';

@Component({
	selector: 'app-configuracion-tipo-interfaz',
	templateUrl: './configuracion-tipo-interfaz.component.html',
	styleUrls: ['./configuracion-tipo-interfaz.component.scss']
})
export class ConfiguracionTipoInterfazComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerTipoInterfaz: Array<string>;
	formTipoInterfaz: FormGroup;
	selectTipoInterfaz: any;

	paginaActual: number;
	// filtros
	filtro: FormGroup;
	public isCollapsed = true;

	constructor(private formBuilder: FormBuilder, private configuracionTipoInterfazService: ConfiguracionTipoInterfazService,
		private modalService: NgbModal) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;

		this.createForm();

		this.onConsultarTipoInterfaz(1);

		this.selectTipoInterfaz = null;
		this.paginaActual = 1;

	}

	ngOnInit() {
		this.headerTipoInterfaz = ['Configuración Tipo Interfaz ID', 'Descripción', 'Estado', 'Acción'];
	}

	createForm() {
		this.formTipoInterfaz = this.formBuilder.group({
			descripcion: [null, Validators.required],
			activo: [true],

		});

		this.filtro = this.formBuilder.group({
			descripcion: [null],
			activo: [null],

		});
	}

	onConsultarTipoInterfaz(page: number) {
		this.configuracionTipoInterfazService.get({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarTipoInterfaz(value);
	}

	onAgregarTipoInterfaz() {

		this.configuracionTipoInterfazService.create({
			...this.formTipoInterfaz.value, activo: 1
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarTipoInterfaz(this.paginaActual);
					this.formTipoInterfaz.reset();
				}
			});
	}

	onOperarTipoInterfaz() {
		if (!this.selectTipoInterfaz) {
			this.onAgregarTipoInterfaz();
		} else {
			this.onModificarTipoInterfaz();
		}
	}

	onCargarTipoInterfaz(entry: any) {
		entry.activo = entry.activo ? 1 : 0;
		this.formTipoInterfaz.patchValue({
			...entry,
		});

		this.selectTipoInterfaz = entry;
	}

	onEliminarTipoInterfaz(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.configuracionTipoInterfazService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					// tslint:disable-next-line:max-line-length
					const index = this.dataTabla.items.map(function (e) { return e.tipo_configuracion_interfaz_id; }).indexOf(entry.tipo_configuracion_interfaz_id);
					this.dataTabla.items.splice(index, 1);
					this.selectTipoInterfaz = null;
					this.formTipoInterfaz.reset();
				}
			});
		});
	}

	onModificarTipoInterfaz() {
		this.configuracionTipoInterfazService.update({
			...this.formTipoInterfaz.value,
			tipo_configuracion_interfaz_id: this.selectTipoInterfaz.tipo_configuracion_interfaz_id
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarTipoInterfaz(this.paginaActual);
					this.formTipoInterfaz.reset();
					this.selectTipoInterfaz = null;
				}
			});
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarTipoInterfaz(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}
	limpiarTipoInterfaz() {
		this.formTipoInterfaz.reset();
		this.selectTipoInterfaz = null;
		this.createForm();
	}
}
